const initState = {
    hoverTarget: {},
    cannonName: 'Battle-cannon',
    infoBox: false,
    spans: '',
    loading: true,
  };
  export default initState;